export enum RegistrationMethod {
	BankId = "bankid",
	Password = "password",
}
